export function getReadTimeMsg(readTime) {
    const msg = [];
    if (readTime.hours > 0) {
        msg.push(`${readTime.hours} hour`);
    }
    if (readTime.minutes > 0) {
        msg.push(`${readTime.minutes + readTime.round} minute`);
    }
    if (!msg.length) {
        msg.push(`Less than a minute`);
    }
    return `${msg.join(", ")} read`;
}
